import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { BaseModalComponent } from '../../../models/base-modal-component';
import { ReviewSystem } from '../../../models/enums';

@Component({
    standalone: false,
    selector: 'res-select-associated-review-project-modal',
    templateUrl: './select-associated-review-project-modal.component.html',
    styleUrls: ['./select-associated-review-project-modal.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class SelectAssociatedReviewProjectModalComponent extends BaseModalComponent implements OnInit {
    modalTitle = 'Select Associated Review Project';
    modalAutomationId = 'select-associated-review-project';
    secondaryButtonLabel = 'Cancel';
    reviewProjects: Array<{ reviewProjectId: number; reviewProjectName: string }> = [];
    reviewSystem: ReviewSystem;
    ReviewSystem = ReviewSystem;

    constructor(private modalService: BsModalService, private modalRef: BsModalRef) {
        super(modalService, modalRef);
    }

    ngOnInit(): void {
        this.reviewProjects = this.modalData?.reviewProjects ?? [];
        this.reviewSystem = this.modalData?.reviewSystem;
    }

    selectProject(project: { reviewProjectId: number; reviewProjectName: string }): void {
        this.closeModal(true, project);
    }
}
